<template>
  <v-dialog
    :persistent="login.persistent"
    content-class="login-modal-dialog rounded-lg ma-1"
    v-model="isModalActive"
    width="900">
    <v-container
      class="modal-card white login-modal px-4"
      v-if="isModalActive">
      <v-row>
        <v-col
          cols="12"
          md="6"
          offset-md="6"
          class="pa-0">
          <div
            class="text-center mb-2">
            <div
              class="text-h6 font-weight-bold">
              Bienvenido a
            </div>
            <img
              src="/static/logotipo.svg"
              style="max-width: 250px;
                      display: block;
                      margin: 0 auto;"
              class="logo"
              alt="Eventeros">
          </div>
          <section class="transparent px-6 px-md-10">
            <div
              class="d-flex pt-5 pb-4">
              <div class="font-weight-bold">
                {{ title }}
              </div>
            </div>
            <slot></slot>
            <v-divider class="my-5" />
            <div class="text-center  text-md-center text-caption">
              Al iniciar sesión aceptas nuestros
              <a
                :href="FRONTOFFICE_URL + '/terminos-y-condiciones'"
                target="_blank"
                class="black--text font-weight-bold">
                Términos y Condiciones</a> y nuestra
              <a
                :href="FRONTOFFICE_URL + '/politica-de-privacidad'"
                target="_blank"
                class="black--text font-weight-bold">
                Política de Privacidad</a>
            </div>
          </section>
        </v-col>
      </v-row>
    </v-container>
  </v-dialog>
</template>

<script>

import { mapActions, mapState } from 'vuex';

export default {
  name: 'LoginLayout',
  props: {
    title: {
      default: 'Iniciar sesión',
    },
  },
  data() {
    return {
      FRONTOFFICE_URL: process.env.VUE_APP_FRONTOFFICE_URL,
      isModalActive: false,
    };
  },
  created() {
    this.isModalActive = this.login.active;
  },
  computed: {
    ...mapState('app/', ['login']),
  },
  watch: {
    isModalActive(val) {
      // when modal has been closed, change state on vue
      if (val === false) {
        this.closeLogin();
      } else {
        this.$emit('opened');
      }
    },
    login: {
      deep: true,
      handler() {
        this.isModalActive = this.login.active;
      },
    },
  },
  methods: {
    ...mapActions('app/', ['closeLogin']),
  },
};
</script>

<style lang="scss">

  .login-modal-dialog {
    max-width: 900px;

    @media screen and (max-width: 960px) {
      max-width: 450px;
    }
  }

</style>

<style lang="scss" scoped>

  .modal-login {
    z-index: 9999;
  }

  .login-modal {
    background-image: url("https://eventeros.b-cdn.net/static/images/imglogin.png");
    background-position: left -60px bottom -40px;
    background-repeat: no-repeat;
    background-size: 55%;
    padding: 60px 0;

    @media screen and (max-width: 960px) {
      background: none;
    }

  }

</style>

<style lang="scss">

  .modal-login {
    .animation-content, .modal-card {
      width: 960px !important;

      @media screen and (max-width: 960px) {
        width: 500px !important;
      }

      @media screen and (max-width: 600px) {
        width: 99% !important;
      }
    }
  }

</style>
